var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8948 10.7368C13.7551 10.7368 15.2632 9.22875 15.2632 7.36842C15.2632 5.50809 13.7551 4 11.8948 4C10.0345 4 8.52637 5.50809 8.52637 7.36842C8.52637 9.22875 10.0345 10.7368 11.8948 10.7368Z",
    stroke: "#0B0A0A",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9804 17.894H17.7895M17.7895 17.894H16.5986M17.7895 17.894V16.7031M17.7895 17.894V19.0849",
    stroke: "#0B0A0A",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8947 13.2656C14.0912 13.2656 16.0071 13.9521 17.0212 14.97M14.9129 19.528C14.0301 19.8293 12.9978 20.0025 11.8947 20.0025C8.63917 20.0025 6 18.4943 6 16.634C6 15.4894 6.99917 14.4781 8.52632 13.8694",
    stroke: "#0B0A0A",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserManagement);
export default __webpack_public_path__ + "static/media/user-management.4abff23197ba419828d788ec52f7dfc1.svg";
export { ForwardRef as ReactComponent };